export const maxLogSize = 100;
export const logReminder = 20;

export class NotificationQueue {
	constructor(executor) {
		this.executor = executor;
		this.queueBusy = false;
		this.queue = [];
		this.recentlyProcessed = new Set();
	}

	get isBusy() {
		return this.queueBusy;
	}

	enqueue(notification) {
		this.queue.push(notification);
		// eslint-disable-next-line max-len
		log(`Notification enqueued ${notification.id} (${notification?.parts?.map(p => p.notification_type)?.join(' + ')})`);
		this.process();
	}

	process() {
		if (!this.isBusy) {
			const nextNotification = this.queue.shift();
			if (nextNotification) {
				if (!this.wasRecentlyProcessed(nextNotification)) {
					this.queueBusy = true;
					this.logProcessing(nextNotification);
					this.executor.run(nextNotification, this.onExecutorEnd.bind(this, nextNotification));
				} else {
					log(`Notification omitted due to recent processing: ${nextNotification.id}`);
					this.process();
				}
			} 
		}
	}

	onExecutorEnd(notification) {
		// eslint-disable-next-line max-len
		log(`Notification processing ended ${notification.id} (${notification?.parts?.map(p => p.notification_type)?.join(' + ')})`);
		this.queueBusy = false;
		this.process();
	}

	logProcessing(notification) {
		this.recentlyProcessed.add(notification.id);
		// eslint-disable-next-line max-len
		log(`Notification processing started ${notification.id} (${notification?.parts?.map(p => p.notification_type)?.join(' + ')})`);
	}

	wasRecentlyProcessed(notification) {
		this.cleanLog();
		return this.recentlyProcessed.has(notification.id);
	}

	cleanLog() {
		if (this.recentlyProcessed.size > maxLogSize) {
			// iteration is in order of insertion
			let counter = this.recentlyProcessed.size;
			for (const notificationId of this.recentlyProcessed.keys()) {
				--counter;
				this.recentlyProcessed.delete(notificationId);
				if (counter <= logReminder) {
					break;
				}
			}
		}
	}

}
